<div class="login-screen">
  <section class="left-panel">
    <div class="bg-circle bg-circle-1"></div>
    <div class="bg-circle bg-circle-2"></div>
    <div class="bg-circle bg-circle-3"></div>
    <div class="dot-pattern"></div>

    <div class="brand">
      <div class="brand-icon">
        <span aria-label="Futuristic logo" class="inline-flex h-11 w-11 items-center justify-center">
          <svg viewBox="0 0 57 61" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-8 w-auto select-none">
            <path
              d="M12.6226 0.743908L5.29707 27.4046C5.12005 28.0488 5.60483 28.6848 6.27295 28.6848H32.9107C33.3701 28.6848 33.7719 28.3753 33.8892 27.931L40.9274 1.27037C41.0969 0.628463 40.6128 0 39.9489 0H13.5985C13.1428 0 12.7433 0.304522 12.6226 0.743908Z"
              fill="#4E7CA7" />
            <path
              d="M41.0028 13.5954L37.1361 27.5596C36.9576 28.2043 37.4425 28.8417 38.1115 28.8417H52.1492C52.6079 28.8417 53.0093 28.5331 53.1272 28.0898L56.8423 14.1257C57.0132 13.4833 56.5289 12.8535 55.8642 12.8535H41.9782C41.5232 12.8535 41.1242 13.157 41.0028 13.5954Z"
              fill="#72B6C3" />
            <path
              d="M23.7497 33.0338L16.4241 59.6945C16.2471 60.3387 16.7319 60.9747 17.4 60.9747H44.0377C44.4972 60.9747 44.899 60.6652 45.0163 60.221L52.0545 33.5603C52.224 32.9184 51.7399 32.2899 51.076 32.2899H24.7255C24.2699 32.2899 23.8704 32.5944 23.7497 33.0338Z"
              fill="#92E0D1" />
            <path
              d="M4.22169 33.0319L0.35502 46.996C0.176506 47.6407 0.66142 48.2782 1.33037 48.2782H15.3681C15.8268 48.2782 16.2282 47.9696 16.3461 47.5263L20.0611 33.5622C20.232 32.9198 19.7478 32.2899 19.0831 32.2899H5.19704C4.74212 32.2899 4.3431 32.5935 4.22169 33.0319Z"
              fill="#B6F0E0" />
          </svg>
        </span>
      </div>
      <div class="brand-content">
        <div class="brand-name">Underwriting Workbench</div>
        <div class="brand-subtitle text-brand font-black ">-------------------
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          ----------</div>
      </div>
    </div>

    <div class="network">
      <div class="orbit orbit-1"></div>
      <div class="orbit orbit-2"></div>
      <div class="orbit orbit-3"></div>

      <svg class="network-svg" viewBox="0 0 430 230" preserveAspectRatio="xMidYMid meet">
        <line x1="82" y1="75" x2="215" y2="130" />
        <line x1="82" y1="75" x2="170" y2="42" />
        <line x1="170" y1="42" x2="290" y2="32" />
        <line x1="290" y1="32" x2="332" y2="118" />
        <line x1="332" y1="118" x2="215" y2="130" />
        <line x1="215" y1="130" x2="112" y2="165" />
        <line x1="215" y1="130" x2="170" y2="42" />
        <line x1="215" y1="130" x2="290" y2="32" />
        <line x1="215" y1="130" x2="332" y2="118" />
        <path d="M82 75 C150 110 270 5 332 118" class="gold-path" />
      </svg>

      <div class="network-node node-1"><span>O</span></div>
      <div class="network-node node-2"><span>[]</span></div>
      <div class="network-node node-3"><span>^</span></div>
      <div class="network-node node-4"><span>*</span></div>
      <div class="network-node node-5"><span>@</span></div>
      <div class="network-node node-6"><span>#</span></div>

      <div class="center-node">
        <div class="center-ripple"></div>
        <div class="center-glow"></div>
        <div class="center-icon">UW</div>
      </div>
    </div>

    <div class="hero-copy">
      <div class="hero-line"></div>
      <h1>Underwriting</h1>
      <h1>intelligence, <span>built for the</span></h1>
      <!-- <h1><span>way you work.</span></h1> -->
      <h1>
        <span>way you work.</span>
        <span class="inline-flex ml-1 gap-0.5 align-baseline">
          <span class="animate-bounce [animation-delay:0ms]">.</span>
          <span class="animate-bounce [animation-delay:150ms]">.</span>
          <span class="animate-bounce [animation-delay:300ms]">.</span>
        </span>
      </h1>
    </div>

    <div class="bottom-dot dot-a"></div>
    <div class="bottom-dot dot-b"></div>
    <div class="bottom-dot dot-c"></div>
    <div class="bottom-dot dot-d"></div>
  </section>

  <section class="right-panel">
    <div class="login-container">
      <h2 class="login-title">Welcome to Underwriting Workbench!</h2>
      <p class="login-description mb-3">Please sign-in to your account and continue to your workspace.</p>

      @if (sessionNotice) {
      <div style="margin-top: 0.5rem; padding: 0.5rem 1rem; border-radius: 0.75rem; border: 1px solid #fcd34d; background-color: #fef3c7; color: #78350f;"
      class="mt-2
      rounded-xl
      border border-amber-200
      bg-amber-50
      px-4 py-2
      text-sm font-medium
      text-amber-900

      dark:border-amber-900/40
      dark:bg-amber-950/30
      dark:text-amber-100">
        {{ sessionNotice }}
      </div>
      }

      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-group mt-2" style="margin-top: 8px;">
          <label for="userId">Work email</label>
          <input id="userId" formControlName="userId" type="email" placeholder="your.email@example.com"
            autocomplete="username" />

          @if (form.controls.userId.invalid && form.controls.userId.touched) {
          <p style="margin-top: 0.5rem; padding: 0.0rem 1rem; color: #78350f;"
            class="mt-2 text-xs font-medium text-status-danger">Work email is required.</p>
          }
        </div>

        <div class="form-group password-group">
          <div class="password-header">
            <label for="password">Password</label>
            <a class="forgot-password" routerLink="/authentication/forgot-password">Forgot password?</a>
          </div>

          <div class="relative">
            <input id="password" formControlName="password" [type]="passwordFieldType()"
              placeholder="Enter your password" class="pr-16" autocomplete="current-password" />

            <button type="button"
              class="absolute right-2 top-1/2 -translate-y-1/2 rounded-full px-2 py-1 text-brand transition hover:text-brand-dark"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="hidePassword() ? 'Show password' : 'Hide password'">
              <i [class]="hidePassword() ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'"></i>
            </button>
          </div>

          @if (form.controls.password.invalid && form.controls.password.touched) {
          <p style="margin-top: 0.5rem; padding: 0.0rem 1rem; color: #78350f;" class="mt-2 text-xs font-medium text-status-danger">Password must be at least 4 characters.</p>
          }
        </div>

        @if (loginError()) {
        <p style="margin-top: 0.5rem; padding: 0.0rem 1rem; color: #78350f;" class="mt-3 text-sm font-medium text-status-danger">{{ loginError() }}</p>
        }

        <button type="submit"
          class="inline-flex h-12 w-full items-center justify-center rounded-xl bg-[linear-gradient(135deg,var(--brand-color,#7367f0)_0%,var(--brand-dark,#5f52db)_100%)] text-[1rem] font-semibold text-white shadow-[0_18px_40px_rgba(var(--brand-rgb),0.28)] transition hover:translate-y-[-1px] hover:shadow-[0_22px_42px_rgba(var(--brand-rgb),0.34)]"
          [disabled]="isSubmitting()" [class.cursor-not-allowed]="isSubmitting()" [class.opacity-80]="isSubmitting()">
          <span>{{ isSubmitting() ? 'Signing in...' : 'Sign in' }}</span>
        </button>
      </form>
    </div>
  </section>
</div>
